import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { H2 } from 'components/core/Typography';
import { Container } from 'components/core/Page';
import { MarkdownWrapper } from 'components/atoms';
import { Image } from 'components/core/Image';

import './SectionHeader.scss';

export function SectionHeader({
	className,
	header = '',
	description = '',
	image = { src: '' },
}) {
	return (
		<div className={classnames(className, 'section-header')}>
			<Container>
				<div className="section-header">
					<Image
						className="section-header-img"
						src={image}
						alt={header}
					/>
					<H2 size="large">{header}</H2>
					<MarkdownWrapper
						content={[{ value: description }]}
						componentProps={{ color: 'black' }}
					/>
				</div>
			</Container>
		</div>
	);
}

SectionHeader.propTypes = {
	className: PropTypes.string,
	image: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.shape({
			src: PropTypes.string,
		}),
	]),
	header: PropTypes.string,
	description: PropTypes.string,
};

export default SectionHeader;
